import { useCallback, useEffect, useState } from 'react';
import { apiService, type SourceSummary } from '../services/api';

/**
 * Catálogo de fontes/agências por escopo — fetch direto (sem React Query).
 */
export function useSourcesSummary(
  scope: 'federal' | 'state' | 'municipal',
  options?: { enabled?: boolean }
) {
  const [data, setData] = useState<SourceSummary[]>([]);
  const [loading, setLoading] = useState(options?.enabled !== false);
  const [error, setError] = useState<Error | null>(null);
  const enabled = options?.enabled !== false;

  const load = useCallback(async () => {
    if (!enabled) {
      setLoading(false);
      return;
    }
    setLoading(true);
    setError(null);
    try {
      const result = await apiService.getSourcesSummaryByScope(scope);
      setData(Array.isArray(result) ? result : []);
    } catch (e) {
      setError(e instanceof Error ? e : new Error(String(e)));
      setData([]);
    } finally {
      setLoading(false);
    }
  }, [scope, enabled]);

  useEffect(() => {
    void load();
  }, [load]);

  return { data, isLoading: loading, error, refetch: load };
}
